<template>
  <v-row wrap justify="space-between" :style="{ height: cta === 'login' ? '' : '70vh' }">
    <v-col cols="12" v-show="!!message">
      <v-row wrap style="margin-top: 2rem">
        <v-col cols="12" style="margin: 30px 0px">
          <h4 style="font-weight: 400; font-size: 18px" v-html="message" />
        </v-col>
        <v-col md="2" sm="3" cols="3">
          <div class="backButton" @click="doLogin()" v-if="cta === 'login'">
            <v-btn rounded color="#fec627">
              <span>Login</span>
            </v-btn>
          </div>
          <div class="backButton" @click="clear()" v-else>
            <v-btn>
              <v-icon style="position: absolute; margin-left: 20px">mdi-arrow-left</v-icon>
              <span style="margin-left: 12px">Back</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue';
import { useUiStore } from '@/stores/ui';

export default defineComponent({
  emits: ['clear'],
  name: 'ErrorComponent',

  data() {
    return {};
  },

  props: {
    message: {
      type: String
    },
    cta: {
      type: String
    }
  },

  methods: {
    clear() {
      const uiStore = useUiStore();
      uiStore.globalError.message = '';

      this.$emit('clear');
    },
    doLogin() {
      this.$auth.login('asurite');
    }
  }
});
</script>
